/**
 * Error Handling Configuration
 * 
 * Centralized configuration for error pages and retry logic
 */

export const ERROR_CONFIG = {
  /** Auto-retry countdown duration in seconds */
  RETRY_COUNTDOWN_SECONDS: 30,
  
  /** Maximum number of automatic retry attempts before stopping */
  MAX_RETRY_ATTEMPTS: 3,
} as const;
